import { all, takeEvery, put, call, fork } from "redux-saga/effects";
import { push } from "react-router-redux";
import { getToken, clearToken } from "../../helpers/utility";
import actions from "./actions";
import { notification } from "../../components";
import {apiLogout, login} from "../../helpers/parseHelper";

const fakeApiCall = false; // auth0 or express JWT

export function* loginRequest() {
  yield takeEvery("LOGIN_REQUEST", function*() {
    if (fakeApiCall) {
      yield put({
        type: actions.LOGIN_SUCCESS,
        token: "secret token",
      });
    } else {
      const username = localStorage.getItem("username");
      const password = localStorage.getItem("password");
      //yield put({ type: actions.LOGIN_ERROR });
    }
  });
}

export function* jwtLoginRequest() {
  yield takeEvery(actions.JWT_LOGIN_REQUEST, function*({ payload }) {
    try {
      const result = yield call(
        login,
        payload.userInfo
      );
      if(result.error){
        notification("error", result.error);
        yield put({
          type: actions.LOGIN_ERROR
        });
      }else{
        yield put({
          type: actions.LOGIN_SUCCESS,
          token: result.sessionToken,
          accessToken: result.apiKey,
          role: result.roleId,
          user_id: result.objectId,
          expireTime: result.expireTime,
          permissionItems: result?.permissionItems,
          userSetting: result?.userSetting,
          roleIndex: result?.roleIndex,
          username: result?.username,
          name: result?.name,
          status: result?.status,
          clientId: result?.clientId || result?.objectId,
          merchants: result?.merchants || ""
        });
        yield put(push("/dashboard"));
      }
    } catch (error) {
      notification("error", error.message);
      yield put({
        type: actions.LOGIN_ERROR
      });
    }
  });
}

export function* loginSuccess() {
  yield takeEvery(actions.LOGIN_SUCCESS, function*(payload) {
    // console.log(`loginSuccess  token : ${payload.token} | user_id : ${payload.user_id}  | expireTime : ${payload.expireTime}`)

    yield localStorage.setItem(
      "id_token",
      payload.token + "|" + payload.expireTime
    );
    yield localStorage.setItem("token", payload.token);
    yield localStorage.setItem("accessToken", payload.accessToken);
    yield localStorage.setItem("user_role", payload.role);
    yield localStorage.setItem("user_id", payload.user_id);
    yield localStorage.setItem("expireTime", payload.expireTime);
    
    yield localStorage.setItem("roleId", payload.roleId);
    yield localStorage.setItem("permissionItems", JSON.stringify(payload.permissionItems || {}));
    yield localStorage.setItem("userSetting", JSON.stringify(payload.userSetting || {}));
    yield localStorage.setItem("roleIndex", payload.roleIndex);
    yield localStorage.setItem("username", payload.username);
    yield localStorage.setItem("name", payload.name);
    yield localStorage.setItem("status", payload.status);
    yield localStorage.setItem("clientId", payload.clientId || payload?.objectId);

    if (payload?.merchants?.indexOf("[") !== -1) {
      yield localStorage.setItem("merchants", payload?.merchants);
    } else {
      if (payload?.merchants && payload?.merchants !== "null") {
        yield localStorage.setItem("merchants", JSON.stringify(payload?.merchants ?? ""));
      }
    }
    // yield localStorage.setItem("merchants", JSON.stringify(payload?.merchants ?? []));
  });
}

export function* loginError() {
  yield takeEvery(actions.LOGIN_ERROR, function*() {});
}

export function* logout() {
  yield takeEvery(actions.LOGOUT, function*() {
        yield call(
          apiLogout,
        );

      clearToken();
      yield put(push("/"));
  });
}

export function* checkAuthorization() {
  yield takeEvery(actions.CHECK_AUTHORIZATION, function*() {
    const id_token = getToken().get("id_token");
    const token = getToken().get("token");
    const accessToken = getToken().get("accessToken");
    const role = getToken().get("role");
    const user_id = getToken().get("user_id");
    const expireTime = getToken().get("expireTime");
    const permissionItems = getToken().get("permissionItems");
    const userSetting = getToken().get("userSetting");
    const roleIndex = getToken().get("roleIndex");
    const username = getToken().get("username");
    const name = getToken().get("name");
    const status = getToken().get("status");
    const clientId = getToken().get("clientId") || getToken().get("objectId");
    const merchants = getToken()?.get("merchants");
    
    // console.log(`checkAuthorization id_token: ${id_token} | token : ${token} | user_id : ${user_id}`)
    var currentTimestamp = Math.round((new Date()).getTime() / 1000);

    if (token && parseInt(id_token?.split('|')[1]) > currentTimestamp ) {
      yield put({
        type: actions.LOGIN_SUCCESS,
        token,
        accessToken,
        role,
        user_id,
        id_token,
        expireTime,
        permissionItems,
        userSetting,
        roleIndex,
        username,
        name,
        status,
        clientId,
        merchants
      });
    } else {
      logout();
    }
  });
}
export default function* rootSaga() {
  yield all([
    fork(checkAuthorization),
    fork(jwtLoginRequest),
    fork(loginRequest),
    fork(loginSuccess),
    fork(loginError),
    fork(logout)
  ]);
}
